export { getUserDetails as getUserDetails };
export { getKycRefData as getKycRefData };
export { getIsLoadingArray as getIsLoadingArray };
export { getCoins as getCoins };
export { getRefData as getRefData };
export { getCountries as getCountries };
import state from './state';

function getUserDetails() {
  return state.user;
}
function getKycRefData() {
  return state.kycRefData;
}
function getIsLoadingArray() {
  return state.isLoadingArray;
}
function getCoins() {
  return state.coins;
}
function getRefData() {
  return state.refData;
}
function getCountries() {
  return state.countries;
}

export default { getUserDetails, getKycRefData, getIsLoadingArray, getCoins, getRefData, getCountries };
